import { Pagination } from '@mui/material'
import styled from 'styled-components'
import { COLORS, SPACING } from 'utils'

export const ContainerFooter = styled.div<{
  gridPercentage?: string
}>`
  display: grid;
  grid-template-columns: 1fr ${props => props?.gridPercentage ? props?.gridPercentage : '15'}%;
  height: 4rem;
  margin-top: ${SPACING.spacing20};
`

export const ContainerPagination = styled.div<{ justifyContent?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${props => props?.justifyContent ? props?.justifyContent : 'center'};
`
export const PaginationStyled = styled(Pagination)`
  .MuiPaginationItem-page {
    border: none;
    color: ${COLORS.black};
  }

  .MuiPaginationItem-page.Mui-selected {
    color: ${COLORS.black};
    background: ${COLORS.primary};
    border-radius: 2px;
    width: 24px;
    height: 36px;
  }
`

export const ContainerSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
